import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import {
  currencyFormatter,
} from '../../../common/utils/helpers';
import { 
  disposeLoanActions,
} from '../../../features/loan-management/ducks';
import { getPrincipalBalance, getNominalBalance } from '../../../common/utils/mathHelpers';
import { loanStatus } from '../../enums';

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({

  actions: bindActionCreators(
    {
      disposeLoan: disposeLoanActions.request,
    },
    dispatch
  ),
});

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },

};

const getLeftOfAmount = (loan, items) => {
  return getPrincipalBalance(loan, items);
}

const getLoanNominalValue = (loan, items) => {
  return getNominalBalance(loan, items);
}

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class DisposeLoanCollapseList extends Component {

  static propTypes = {
    t: PropTypes.func.isRequired,
    loan: PropTypes.object,
    items: PropTypes.array,
  };

  onSubmit = () => {
    const { actions, loan, items } = this.props;
    const mapToSend = new Map();
    let input = document.getElementById(`inp${loan.loanNumber}`);
    mapToSend.set(loan.loanNumber, {
      amount: input.value,
      nominalAmount: getLoanNominalValue(loan, items)
    });
    actions.disposeLoan({loanId: loan.id, body: mapToSend});
  };

  render() {
    const { 
      loan, 
      t,
      items
    } = this.props;

    if (loan.disposals) {
      return (
        <div>
          <Form.Item {...formItemLayout} label={t('Menovitá hodnota')}>
            <span>{currencyFormatter(loan.disposals.nominalAmount)}</span>
          </Form.Item>
  
          <Form.Item {...formItemLayout} label={t('Kupná cena')}>
            <span>{currencyFormatter(loan.disposals.amount)}</span>
          </Form.Item>
        </div>
      );
    } else {
      return (
        <div>
          <Form.Item {...formItemLayout} label={t('Zostatok istiny')}>
            <span>{currencyFormatter(getLeftOfAmount(loan, items))}</span>
          </Form.Item>
          
          <Form.Item {...formItemLayout} label={t('Menovitá hodnota')}>
            <span>{currencyFormatter(getLoanNominalValue(loan, items))}</span>
          </Form.Item>
  
          <Form.Item {...formItemLayout} label={t('Kupná cena')}>
            <Input id={`inp${loan.loanNumber}`} defaultValue={getLeftOfAmount(loan, items)} style={{width: "200px"}} readOnly></Input>
          </Form.Item>
  
          <Form.Item>
              <Button size="default" type="primary" onClick={this.onSubmit}>
                {t('Zrealizovať odpredaj')}
              </Button>
          </Form.Item>
        </div>
      );
    }
  }
}




// WEBPACK FOOTER //
// ./src/common/components/data-display/DisposeLoanCollapseList.js